import { getLogo, truncateString } from '../../helpers/functions';
import InfoTooltip from '../InfoTooltip/Info-tooltip';
import { Icon } from '../UI';
import { useNavigate } from 'react-router-dom';
import { TAssetType } from '../../types/model';

export const Asset = ({
  connectionType = '',
  exchange = '',
  id,
  logo,
  name,
  symbol,
  type,
  isClickable = true,
  size = 'base',
  showSubtitle = true,
  subtitleClassName = 'text-grey-50 text-xs ',
  titleClassName = 'text-black font-medium uppercase ',
  showBorder = true,
  maxChars = 11,
}: {
  connectionType?: string;
  exchange?: string | null;
  id: string;
  logo: string;
  name: string;
  symbol: string;
  type: TAssetType | '';
  isClickable?: boolean;
  size?: 'base' | 'large';
  showSubtitle?: boolean;
  showBorder?: boolean;
  maxChars?: number;
  subtitleClassName?: string;
  titleClassName?: string;
}) => {
  const navigate = useNavigate();

  const handleClick = (ev) => {
    if (hasLink) {
      window.open(`/market/${id}/${type}/withoutFilter/overview`, '_blank');
    }
  };

  let title = symbol || '';
  let subtitle = name || '';
  let hasLink = false;

  switch (type) {
    case 'INDEX':
      hasLink = false;
      break;
    case 'NFT':
      title = name.includes('#') ? '#' + name.split('#')[1] : name;
      subtitle = name.includes('#') ? name.split('#')[0] : name;
      hasLink = false;
      break;
    case 'ESTATE':
      title = name;
      subtitle =
        name.split(' ').length > 2 ? name.split(' ').slice(-2).join(' ') : name;
      hasLink = false;
      break;
    case 'USER':
      title = name;
      subtitle = connectionType === 'WALLET' ? 'Wallet' : '';
      hasLink = false;
      break;
    default:
      hasLink =
        isClickable &&
        connectionType !== 'WALLET' &&
        connectionType !== 'BANK' &&
        !!type;
  }

  return (
    <a
      className={`inline-flex h-full w-full items-center justify-start
        ${hasLink ? 'cursor-pointer' : ''} `}
      onClick={handleClick}
    >
      <span
        className={`flex flex-shrink-0 overflow-hidden rounded-full border-1 
          ${
            showBorder
              ? 'border-grey-10 dark:border-grey-90'
              : 'border-transparent'
          }`}
      >
        <span
          className={`flex flex-shrink-0 justify-center items-center bg-white dark:bg-black rounded-full overflow-hidden ${
            size === 'large' ? 'h-12 w-12' : 'h-7 w-7'
          }`}
        >
          <img
            className={`object-scale-down w-full ${
              size === 'large' ? 'h-12' : 'h-7'
            }`}
            src={getLogo(type, logo)}
            alt={symbol}
          />
        </span>
      </span>
      <span
        className={`flex flex-shrink overflow-hidden break-all flex-col ${
          size === 'large' ? 'ml-4' : 'ml-2'
        }`}
      >
        <span
          className={`font-medium uppercase ${
            size === 'large' ? 'text-lg' : 'text-sm'
          }
          ${titleClassName}`}
        >
          {truncateString(title, maxChars)}
        </span>
        <span
          className={`
            ${!showSubtitle ? 'hidden' : 'inline'}
            ${subtitleClassName}
          `}
        >
          {truncateString(subtitle, maxChars + 4)}
          {exchange ? ` (${truncateString(exchange, 11)})` : ''}
        </span>
      </span>
      {connectionType && connectionType !== 'MANUAL' && (
        <InfoTooltip
          placement="right"
          tooltipClassname={'inline-flex flex-shrink-0 ml-auto mr-2'}
          content={'Imported asset cannot be edited manually'}
          isTooltipIconVisible
          tooltipPopupClassname={'flex w-96'}
        >
          <Icon svgName="lock" className="h-3 w-3 ml-1" />
        </InfoTooltip>
      )}
    </a>
  );
};
